module.exports = __webpack_public_path__ + "media/images/orion_pictos/orion-car-2a93385d21899399739326a1bcfa9735.svg";